export default __webpack_public_path__ + "static/media/bannermaspromoMS_30porcientoOff_330x330.02819bd7.webp";